module.exports = __webpack_public_path__ + "img/FUTURE_Hexa_angeschnitten.98f2fe3e.svg";